module.exports = __webpack_public_path__ + "nc_static/media/devicesUsage.169d61d5.svg";